import {PearlHarbor} from "../../PearlHarbor";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {IDogFight, IFinalWave} from "../../server/PearlHarborData";
import {gsap, Linear, TimelineLite, TweenLite} from "gsap";

export class HitChanceBoard extends PIXI.Container implements StageLayer {

    private readonly HIT_CHANCE:PIXI.TextStyle = new PIXI.TextStyle({
        "fontFamily" : "Arial",
        "dropShadowAlpha" : 0.2,
        "fontSize" : 130,
        "fontWeight" : "bold",
        "lineJoin" : "round",
        "miterLimit" : 16,
        "stroke" : "white",
        "strokeThickness" : 9
    });
    private readonly HIT:PIXI.TextStyle = new PIXI.TextStyle({
        "fontFamily" : "Arial",
        "dropShadowAlpha" : 0.2,
        "fill" : "red",
        "fontSize" : 140,
        "fontWeight" : "bold",
        "lineJoin" : "round",
        "miterLimit" : 16,
        "stroke" : "white",
        "strokeThickness" : 9
    });
    private readonly MISS:PIXI.TextStyle = new PIXI.TextStyle({
        "fontFamily" : "Arial",
        "dropShadowAlpha" : 0.2,
        "fill" : "#2a42a2",
        "fontSize" : 140,
        "fontWeight" : "bold",
        "lineJoin" : "round",
        "miterLimit" : 16,
        "stroke" : "white",
        "strokeThickness" : 9
    });

    private _hitChance:PIXI.Text;
    private _textHIT:PIXI.Text;
    private _textMISS:PIXI.Text;
    private _dogfight:PIXI.Sprite;

    public reset():void {
        this.removeChildren();
        this.visible = false;
    }

    private init():void {
        this._hitChance = new PIXI.Text("X", this.HIT_CHANCE);
        this._hitChance.anchor = new PIXI.Point(0.5, 0.5);
        this._hitChance.position.set(360, 90);
        this._hitChance.scale.set(0.8);

        this._textHIT = new PIXI.Text(PearlHarbor.apiPlugin.translations.translate("HIT"), this.HIT);
        this._textHIT.anchor = new PIXI.Point(0.5, 0.5);
        this._textHIT.position.set(360, 150);
        this._textHIT.scale.set(0.8);

        this._textMISS = new PIXI.Text(PearlHarbor.apiPlugin.translations.translate("MISS"), this.MISS);
        this._textMISS.anchor = new PIXI.Point(0.5, 0.5);
        this._textMISS.position.set(360, 150);
        this._textMISS.scale.set(0.8);

        this._dogfight = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("dogfight")[0]);
        this._dogfight.anchor = new PIXI.Point(0.5, 0.5);
        this._dogfight.position.set(360, 200);
        this._dogfight.scale.set(0.8);

        this.visible = false;
    }

    constructor() {
        super();
        this.name = "HitChanceBoard";

        this.init();
    }

    public displayHitResult(id:number, row:boolean):TimelineLite {
        const data:IFinalWave | IDogFight = PearlHarbor.model.dogfight,
            hit:boolean = row ? (<IFinalWave>data).bombHit[id] : data.mgHit[id],
            text:PIXI.Text = hit ? this._textHIT : this._textMISS;

        return new TimelineLite().add([
            () => {
                this.removeChildren();
                text.visible = true;
                this.addChild(text);
            },
            TweenLite.fromTo(text, 0.5, {alpha : 0.2}, {alpha : 1, ease : Linear.easeOut})
        ], 0).add(TweenLite.to(text, 0.2, {alpha : 0}))
            .add(() => {
                this.reset();
            });
    }

    public displayHitChance(id:number, row:boolean):TimelineLite {
        const data:IFinalWave | IDogFight = PearlHarbor.model.dogfight,
            chance:number = row ? (<IFinalWave>data).bombAttackHitChance[id] : data.mgAttackHitChance[id];

        const tl = gsap.timeline();
        tl.add([
            () => {
                this._hitChance.text = chance.toString() + "%";
                this._hitChance.visible = true;
                this.addChild(this._hitChance);
                if(!row) {
                    this.addChild(this._dogfight);
                    this._dogfight.alpha = 1;
                }
                this.visible = true;
            },
            gsap.fromTo(this._hitChance, {alpha : 1}, {duration : 2, alpha : 1})
        ]);
        tl.add([
            gsap.to(this._hitChance, {duration : 0.2, alpha : 0}),
            gsap.to(this._dogfight, {duration : 0.2, alpha : 0})
        ]);
        return tl;
    }
}